import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getQSVar } from '../../utils';

interface IProps {
    className?: string;
}

const BaseHeader = ({ className }: IProps) => {
    const { t: translate } = useTranslation();
    const isTemplateMultifocal = getQSVar('template') === 'multifocal';

    return (
        <div className={className}>
            <h2>
                {translate(
                    isTemplateMultifocal
                        ? 'instructionHeaderMultifocalTemplate'
                        : 'instructionHeader'
                )}
            </h2>
            <p>{translate('instructionBody')}</p>
        </div>
    );
};

export const Header = styled(BaseHeader)`
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    padding: 0 15px;
`;
